import { render, staticRenderFns } from "./IconDocumentDownloadOutline.vue?vue&type=template&id=aa323a2a"
import script from "./IconDocumentDownloadOutline.vue?vue&type=script&lang=js"
export * from "./IconDocumentDownloadOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports